module.exports = __webpack_public_path__ + "img/SKMJ_check6.e00ed173.png";